import React, {useEffect} from 'react';
import styles from './PrivacyPolicy.module.css';
import PrivacyPolicyText from '../Components/PrivacyPolicy';
import Footer from '../../Desktop/Components/Footer';
const PrivacyPolicy = ({onNavigate}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className={styles.communityGuidelines}>
      <div className={styles.body}>
      <h2 className={styles.titleText}>Privacy policy</h2>
      </div>
      <div className={styles.text}>

        <PrivacyPolicyText/>
      </div>
      <Footer onNavigate={onNavigate}/>
    </section>
  );
};

export default PrivacyPolicy;
